module.exports = __webpack_public_path__ + "3fb8cbf10f18cf3280cd0b679618893c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/settings-gears-white.png
// module id = 3704
// module chunks = 0